/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Td } from './css';
import getFormattedPricing from '../../utils';
import { getTotalSmartDocks } from '../../ratePlans/util';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const Row = ({
  hardware,
  productSelected,
  viewType,
  rowData,
  technicalServices,
  setTechnicalServices
}) => {
  const {
    contentfulValues: { valueNorthStarSystemsFarmAndRanch }
  } = useLocalizedStringsContext();

  const {
    fields: {
      serviceName,
      serviceRate,
      serviceDescription,
      servicePrice,
      servicePriceEditible
    }
  } = rowData;

  const [quantity, setQuantity] = useState(
    _.get(technicalServices, `${serviceName}-${serviceRate}.quantity`, 0)
  );
  const [miscPrice, setMiscPric] = useState(
    _.get(technicalServices, `${serviceName}-${serviceRate}.servicePrice`, 0)
  );
  const [isRowDisabled, setIsRowDisabled] = useState(false);

  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);
  const price = servicePriceEditible ? +miscPrice : servicePrice;

  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    if (servicePriceEditible && !miscPrice) setQuantity(0);
    setTechnicalServices(previousValue => ({
      ...previousValue,
      [`${serviceName}-${serviceRate}`]: {
        quantity: +quantity,
        servicePrice: price
      }
    }));
  }, [miscPrice, quantity, servicePrice]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setQuantity(0);
    }
    rowRef.current = true;
  }, [viewType]);

  useEffect(() => {
    if (productSelected === valueNorthStarSystemsFarmAndRanch) {
      const totalSmartDockSelected = getTotalSmartDocks(hardware);
      if (totalSmartDockSelected === 0) {
        setIsRowDisabled(true);
        setMiscPric(0);
        setQuantity(0);
      } else setIsRowDisabled(false);
    }
  }, [hardware]);

  return (
    <tr>
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
        {serviceName}
      </Td>
      <Td>{serviceRate}</Td>
      <Td>{serviceDescription}</Td>
      <Td>
        {servicePriceEditible ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span>$</span>
            <input
              disabled={isRowDisabled}
              style={{ maxWidth: '75%' }}
              className="frg-input-field color-light"
              value={miscPrice}
              onChange={e => {
               let value = e.target.value;
               if (value.length > 1) value = value.replace(/^0+/, '');
               setMiscPric(value);
              }}
              // onChange={e => setMiscPric(e.target.value)}
            />
          </div>
        ) : (
          <>
            {getFormattedPricing(price)}
            {serviceRate === 'kilometre' ? '/km' : ''}
          </>
        )}
      </Td>
      <Td>
        <input
          disabled={(servicePriceEditible && !miscPrice) || isRowDisabled}
          className="frg-input-field color-light"
          value={quantity}
          onChange={e => {
            let value = e.target.value;
            if (value.length > 1) value = value.replace(/^0+/, '');
            setQuantity(value);
          }}
          // onChange={e => setQuantity(e.target.value)}
        />
      </Td>
      <Td>{getFormattedPricing(price * quantity)}</Td>
    </tr>
  );
};

Row.propTypes = {
  hardware: PropTypes.shape({}).isRequired,
  productSelected: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      serviceName: PropTypes.string,
      serviceRate: PropTypes.string,
      serviceDescription: PropTypes.bool,
      servicePrice: PropTypes.number,
      servicePriceEditible: PropTypes.bool.isRequired
    })
  }).isRequired,
  technicalServices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setTechnicalServices: PropTypes.func.isRequired
};

export default Row;
